import React from "react";
import CheckIcon from '@material-ui/icons/Check';

interface StepIconProps {
  active?: boolean;
  completed?: boolean;
  icon: React.ReactNode;
}

export const WizardStepIcon: React.FC<StepIconProps> = ({
  active,
  completed,
  icon,
}) => {
  const isActive = active || completed;

  return (
    <div
      style={{
        width: 28,
        height: 28,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: isActive
          ? '1px solid #f1f4f5'
          : '1px solid #d0d0d0',
        backgroundColor: isActive
          ? '#15a36a'
          : '#f1f4f5',
        color: isActive
          ? '#ffffff'
          : '#666',
        fontSize: 12,
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'all .2s ease',
      }}
    >
      {isActive ? (
        <CheckIcon style={{ fontSize: 14 }} />
      ) : (
        icon
      )}
    </div>
  );
};